/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Latitude_RequiredInputs */

const cs_validation_latitude_required = /** @type {(inputs: Validation_Latitude_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeměpisná šířka je povinná`)
};

const en_validation_latitude_required = /** @type {(inputs: Validation_Latitude_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latitude is required`)
};

/**
* | output |
* | --- |
* | "Latitude is required" |
*
* @param {Validation_Latitude_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_latitude_required = /** @type {((inputs?: Validation_Latitude_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Latitude_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_latitude_required(inputs)
	return cs_validation_latitude_required(inputs)
});